import { ChevronDownIcon } from 'components/icons/Icon'
import styles from './styles/OpenerIcon.css'

const OpenerIcon = ({ show, className }) => {
  return (
    <div className={`${styles.folder} ${show && styles.folderDown} ${className || styles.defaultSpacing}`}>
      <ChevronDownIcon size={16} />
    </div>
  )
}

export default OpenerIcon
